import { isPlatformServer } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
import { getMobileOperatingSystem } from '../../../lib/detect-mobile-os';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { GalleryTeaserUrlPipe } from '../../../shared/pipes/gallery-teaser-url.pipe';

@Component({
  selector: 'app-gallery-pwa-page',
  imports: [LoadingIndicatorComponent, GalleryTeaserUrlPipe, SvgComponent, ButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gallery-pwa-page.component.html',
  styleUrl: './gallery-pwa-page.component.scss',
})
export class GalleryPwaPageComponent {
  private route = inject(ActivatedRoute);
  private platformId = inject(PLATFORM_ID);
  isServer = isPlatformServer(this.platformId);
  os = this.isServer ? undefined : getMobileOperatingSystem();
  gallery = toSignal(this.route.parent.data.pipe(map(data => data.gallery)));
  installPrompt = signal<Event & { prompt: () => void }>(undefined);

  constructor() {
    if (this.isServer) return;

    window.addEventListener('beforeinstallprompt', (e: Event & { prompt: () => void }) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.installPrompt.set(e);
    });
  }
}
